// Builder 定数定義
// マジックナンバーを抽出して一元管理

import { Vector3D } from "common/types";

// グリッドサイズ
export const MAP_MESH_SIZE = 2;
export const DEFAULT_MAP_SIZE: Vector3D = { x: 5, y: 5, z: 5 };

// カメラ設定
export const CAMERA_CONFIG = {
  alpha: Math.PI / 4,
  beta: Math.PI / 4,
  radius: 22,
  target: { x: 5, y: 0, z: 5 },
  lowerBetaLimit: 0,
  upperBetaLimit: Math.PI / 2,
  radiusOffset: 10,
} as const;

// ライト設定
export const LIGHT_CONFIG = {
  direction: { x: 0, y: 1, z: 0 },
  intensity: 1.5,
} as const;

// マテリアル透明度
export const MATERIAL_ALPHA = {
  ground: 0,
  groundPreview: 0.3,
  meshPreview: 0.8,
  meshSelected: 0.8,
  meshNormal: 1,
} as const;

// UI サイズ
export const UI_SIZE = {
  rotateButtonWidth: "80px",
  rotateButtonHeight: "80px",
  rotateButtonOffsetY: 150,
} as const;

// アセットサイズ
export const BUTTON_ASSET_SIZE: Vector3D = { x: 1.6, y: 0.3, z: 1.6 };

// 回転角度
export const ROTATION_STEP = Math.PI / 2; // 90度

// Undo/Redo スタックサイズ
export const MAX_UNDO_STACK_SIZE = 50;
